import { motion } from 'framer-motion';

const DashboardPageTransition = ({ children, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.3, ease: 'easeOut' }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default DashboardPageTransition;
